module.exports = __webpack_public_path__ + "static/img/7.2f1aaea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/7.png
// module id = Hi/y
// module chunks = 0